import React, { useContext, useEffect, useCallback } from "react";
import {Form, Input, Button, Row, Col, Modal, notification, Switch, Space} from "antd";
import axios from "axios";
import GlobalContext from "../../utils/GlobalContext";
import moment from "moment";
import formatTimestamp from "../../utils/FormatTimestamp"
const { TextArea } = Input;

const AgreementActionFollowupForm = ({
    open, 
    onFinish, 
    onCancel, 
    currentAgreementId, 
    currentMeetingPointDetailName,
    currentMeetingPointDetailId,
    nextMeetingStartDate }) => {

  const globals = useContext(GlobalContext);
  const [form] = Form.useForm();
  const [implementationData, setImplementationData] = React.useState(false);
  const [currentAgreement, setCurrentAgreement] = React.useState(null);

  const fetchCurrentAgreement = useCallback(async () => {
    try {
      if (!currentAgreementId) return;
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/consult-agreements/${currentAgreementId}`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setCurrentAgreement(response?.data?.data);
    } catch (error) {
      console.error("Error fetching agreement:", error);
      notification.error({
        message: "Error obteniendo acuerdo",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token, currentAgreementId]);


  useEffect(() => {
    fetchCurrentAgreement();
  }, [fetchCurrentAgreement, currentAgreementId, open]);

  useEffect(() => {
    if (!currentAgreement) return;
    form.setFieldsValue({
      date: (currentAgreement) ? moment(currentAgreement?.date).format("YYYY-MM-DD") : null,
      criterion: currentAgreement?.criterion,
      responsible: currentAgreement?.responsible,
      executor: currentAgreement?.executor,
      observation: currentAgreement?.observation,
      implementationDate: (currentAgreement) ? moment(currentAgreement?.implementationDate).format("YYYY-MM-DD") : null,
      next_meeting_Id: currentAgreement?.next_meeting_Id,
      next_meeting_date: formatTimestamp(nextMeetingStartDate),
    });
    setImplementationData(currentAgreement?.implementation);
  }, [form, currentAgreement, open, nextMeetingStartDate]);

  const handleComplete = async (values) => {
    try {
      let request = getRequest();
      request = {...request, ...values};
      request.implementation = (implementationData) ? 1 : 0;
      request.meetingPointDetailId = currentMeetingPointDetailId;
      if (request.implementationDate === "Invalid date" || request.implementationDate === null){
        request.implementationDate = null;
      }
      console.log("request edit", request);
      await axios.put(
        `${globals.SERVICE_API_DB}/v1/update-agreements/${currentAgreementId}`,
        request,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      notification.success({
        message: "Acuerdo actualizado exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
      form.resetFields();
      onFinish();
    } catch (error) {
      console.error("Error submitting form:", error);
      notification.error({
        message: "Error guardando acuerdo",
        placement: "bottomRight",
      });
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const getRequest = () => {
    return {
      "executor": "",
      "implementation": 0,
      "observation" : "",
      "result": "",
      "implementationDate": null,
      "successful": 0,
    }
  }

  return (
    <Modal
      title={"Actualizar acuerdo de acción"}
      open={open}
      onCancel={handleCancel}
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={handleComplete}>
        <span style={{fontWeight: "bold"}}>Punto de reunión: </span><span>{currentMeetingPointDetailName}</span>
        <hr />
        <Row gutter={16}> 
          <Col span={12}>
            <Form.Item
                name="date"
                label="Fecha planificada"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese la fecha planificada",
                  },
                ]}
              >
                <Input 
                  type="date"
                  disabled={true}
                />
              </Form.Item>
          </Col>
          <Col span={12}>
          <Form.Item
            name="next_meeting_date"
            label="Reunión donde se revisará"
            rules={[
              {
                required: false,
                message: "Por favor seleccione la próxima reunión",
              },
            ]}
          >
            <Input
                disabled={true}
              />
          </Form.Item>
          </Col>
        </Row>
            <Form.Item
              name="criterion"
              label="Entregable o criterio de cumplimiento"
              rules={[
                {required: true,  message: "Por favor ingrese el entregable",},
              ]}
            >
              <TextArea
                 rows={3} 
                 disabled={true}
              />
            </Form.Item>
            <Form.Item
            name="responsible"
            label="Email del Responsable de cumplimiento"
            tooltip="Seleccione un responsable de la lista de invitados "
            rules={[
              { type: 'email', message: "Ingrese un email válido" },
              { required: true, message: "Por favor ingrese el responsable" },
            ]}
          >
            <Input
              value={currentAgreement?.responsible}
              disabled={true}
            />
          </Form.Item>
            <Form.Item
            name="executor"
            label="Email del Ejecutor asignado"
            tooltip="Ingrese el correo electrónico del ejecutor"
            rules={[
              { type: 'email', message: "Ingrese un email válido" },
            ]}
          >
            <Input
              placeholder="Ingrese el correo electrónico del ejecutor"
              disabled={true}
            />
          </Form.Item>
        <Form.Item
          name="implementation"
          label="Implementación"
        >
          <Space direction="vertical">
            <Switch 
              checkedChildren="Si" 
              unCheckedChildren="No" 
              onChange={(value) => setImplementationData(value)}
              value={implementationData}
            />
          </Space>
        </Form.Item>
        <Form.Item
          name="implementationDate"
          label="Fecha de Implementación"
        >
          <Input type="date"/>
        </Form.Item>
        <Form.Item 
          name="observation"
          label="Observaciones de implementación" 
        >
          <TextArea 
            rows={3} 
          />
        </Form.Item>
        <Row justify="end">
          <Col>
            <Button 
              style={{ marginRight: 8 }} 
              type="primary" 
              htmlType="submit"
            >
              Actualizar
            </Button>
            <Button style={{ marginRight: 8 }} onClick={handleCancel}>
              Cancelar
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AgreementActionFollowupForm;
